import React, { useEffect, useState } from "react";

import { ApiBaseUrl } from "../env";

export default function AdminResultsViewer() {
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        fetch(ApiBaseUrl+"/results", {
            method: "GET",
            credentials: "include"
        })
            .then((res) => {
                if (!res.ok) throw new Error("Nicht autorisiert oder Fehler beim Laden");
                return res.json();
            })
            .then(setEntries)
            .catch((err) => {
                console.error("Fehler beim Laden:", err);
                setError(err.message);
            });
    }, []);


    if (loading) return <p className="p-4">Lade Ergebnisse...</p>;
    if (error) return <p className="p-4 text-red-500">{error}</p>;

    return (
        <div className="p-4 max-w-6xl mx-auto">
            <h1 className="text-2xl font-bold mb-4">Admin: Ergebnisse</h1>
            {entries.map((entry) => (
                <div key={entry.id} className="bg-white rounded-xl shadow p-4 mb-4">
                    <p><strong>Name:</strong> {entry.firstName} {entry.lastName}</p>
                    <p><strong>Firma:</strong> {entry.company}</p>
                    <p><strong>E-Mail:</strong> {entry.email}</p>
                    <p><strong>Datum:</strong> {entry.createdAt}</p>
                    <p><strong>Dauer:</strong> {entry.duration} ms</p>
                    <p className="mt-2"><strong>Analyse:</strong><br />
                        <span className="whitespace-pre-wrap text-sm text-gray-700">
              {entry.analysis || <em>Keine Analyse</em>}
            </span>
                    </p>
                    <details className="mt-2">
                        <summary className="cursor-pointer text-blue-500">Rohdaten anzeigen</summary>
                        <pre className="bg-gray-100 p-2 text-xs overflow-auto">
              {JSON.stringify(entry, null, 2)}
            </pre>
                    </details>
                </div>
            ))}
        </div>
    );
}
